export default "__VITE_ASSET__CeEndT8Y__"